import Vue from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'

Vue.use(VueReCaptcha, { 
    siteKey: '6LdWTqEUAAAAAHnoZ7piI2iOIcyydx4a3nuKd0eg',
    loaderOptions: {
        autoHideBadge: true
    }
})
